<template>
  <div class="login">
    <div class="login-box">
      <div class="login-head">
         <Head></Head>
       </div>
       <div class="login-main">
         <div class="form">
            <span>邮箱</span>
            <input type="text" v-model="formData.email"><br>
            <span class="msg">请输入你需要改密码的邮箱</span>
         </div>
         <button class="login-btn" @click="submit">发送至邮箱</button>
       </div>
    </div>
  </div>
</template>

<script>
import Head from "./components/loginhead"
export default {
  data (){
    return{
      formData:{
        email:''
      }
    }
  },
  components:{
    Head
  },
   methods: {
      submit(){
        let urls=  window.location.origin + '/findPassword'
        if(this.formData.email !== ''){
              this.$api.main.forgetword({
            email:this.formData.email,
            url: urls
          }).then(res=>{
            if(res.status == 1){
              this.$message.closeAll()
              this.$message.success('已成功发送至邮箱请注意查收')
              this.$router.push({path:"/orderSubmit",query:{type : 'forget'}});
            }else{
              this.$message.closeAll()
              this.$message.error(res.msg)
            }
          })
        }else{
          this.$message.closeAll()
          this.$message.warning('请您先输入邮箱在修改密码')
        }
    
      },
      forget(){
        this.$router.push('/forgetPassword')
      }
  },
}
</script>

<style lang="less" scoped>
.login{
  width: 1920px;
  height:100vh;
  background: url("http://office.bioleaper.com.cn:6681/static/images/bg-login.jpg") no-repeat;
  background-size: 100% 100%;
  position: relative;
  .login-box{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    height:908px;
    width: 1200px;
    background: #fff;
    border-radius: 9px 9px 0px 0px;
    .login-head{
      width: 1200px;
      height:117px;
    }
    .login-main{
      width: 553px;
      height: 21px;
      font-size: 16px;
      text-align: left;
      color: #333333;
      letter-spacing: 1px;
      margin-left: 300px;
      margin-top: 61px;
      .form{
        width: 600px;
        height: 77px;
        background: #ffffff;
        margin-top: 11px;
          p{
            span{
              color: red;
            }
          }
        input{
          width: 600px;
          height: 40px;
          background: #ffffff;
          border: 1px solid #d8d8d8;
          margin-top: 16px;
          margin-bottom:11px ;
        }
      }
      .password-anquan{
        width: 91px;
        height: 16px;
        font-size: 12px;
        text-align: left;
        color: #999999;
        letter-spacing: 1px;
        margin-top: 18px;
      }
      .checked{
        width: 600px;
        height: 40px;
        margin-top: 36px;
        .checkbox{
          width: 12px;
          height: 12px;
          background: #ffffff;
          border: 1px solid #d8d8d8;
        }
        span{
          font-size: 12px;
          text-align: left;
          color: #333333;
          letter-spacing: 1px;
        }
        .checked-text{
          width: 195px;
          height: 16px;
          margin-left: 7px;
        }
        .not-register{
          width: 65px;
          height: 16px;
          margin-left: 321px;
        }
      }
      .login-btn{
        width: 600px;
        height: 40px;
        background: #ffbb00;
        color:#003871;
        margin-top: 104px;
      }
      button{
        border:0px
      }
      .bottom-text{
        display: flex;
        margin-left: 79px;
        input{
          width: 12px;
          height: 12px;
          background: #ffffff;
          border: 4px solid #ffbb00;
          margin-top: 23px;
        }
        p{
          width: 424px;
          height: 16px;
          margin-top: 20px;
          margin-left: 7px;
          font-size: 12px;
          color: #333333;
          letter-spacing: 1px;
          span{
            color: #ffbb00;
          }
        }
      }
    }
  }
}
</style>